/* unplugin-vue-components disabled */import { render } from "./projectModal.vue?vue&type=template&id=fc2b15ce&scoped=true&ts=true"
import script from "./projectModal.vue?vue&type=script&lang=ts"
export * from "./projectModal.vue?vue&type=script&lang=ts"

import "./projectModal.vue?vue&type=style&index=0&id=fc2b15ce&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc2b15ce"]])

export default __exports__